if (window.innerWidth <= 769) {
  var swiperUgc = new Swiper('.hoox-ugc__swiper', {
    // Optional parameters
    loop: true,
    infinite: true,
    slidesPerView: 1.5,
    spaceBetween: 20,
    // slidesPerGroup: 1,
    breakpoints: {
      768: {
        slidesPerView: 4,
        slidesPerGroup: 4,
        loop: false,
        watchOverflow: true,
        spaceBetween: 0,
      },
    },


    // If we need pagination
    pagination: {
      el: '.hoox-ugc__pagination',
      clickable: true
    }
  });
}